import { clearSandboxProvisionCache } from "@/pages/canvas/nodes/widgets/terminal/sandboxProvision";
import { clearSessionQueryCaches } from "@/queryPersistence";
import { useAuth0 } from "@auth0/auth0-react";
import React, { useEffect } from "react";

const Logout: React.FC = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    // Drop any cached sandbox terminal URLs/tokens before the Auth0 redirect tears down module state.
    clearSandboxProvisionCache();
    // Wipe the persisted query cache so the next login on this browser can't
    // see this session's data.
    clearSessionQueryCaches();
    const ROOT_URL = window.location.origin;
    logout({ logoutParams: { returnTo: ROOT_URL } });
  }, []);

  return null;
};

export default Logout;
